define("ROOM4.CCAWSwiperLoader.CCAWSwiperLoader", [
  "ROOM4.CCAWSwiperLoader.swiperDeferred",
  "Utils",
], function (swiperDeferred, Utils) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      var Environment = container.getComponent("Environment");
      if (Environment.isPageGenerator()) {
        return;
      }

      var styles = document.createElement("link");
      styles.href = Utils.getAbsoluteUrl(
        getExtensionAssetsPath("packages/swiper-bundle.min.css")
      );
      styles.rel = "stylesheet";
      document.head.appendChild(styles);

      var script = document.createElement("script");
      script.src = Utils.getAbsoluteUrl(
        getExtensionAssetsPath("packages/swiper-bundle.min.js")
      );
      script.type = "text/javascript";
      script.async = true;
      script.onload = function () {
        swiperDeferred.__resolve && swiperDeferred.__resolve(window["Swiper"]);
      };
      script.onerror = function () {
        swiperDeferred.__reject &&
          swiperDeferred.__reject(new Error("Failed to load Swiper library"));
      };
      document.head.appendChild(script);

      // Optional: expose for debugging/legacy convenience
      document["deferredSwiper"] = swiperDeferred;
    },
  };
});
